/* eslint-disable */
const DEFAULT_DATA = {
    0: {
        option_name: '期权名称',
        volume: '成交量',
        value: '成交额',
        direction: '成交方向',
        optionIv: '隐含波动率',
        delta: 'Delta值',
        price: '成交价',
        openInterest: '持仓量',
        buy: '主动买入',
        sell: '主动卖出',
        neutral: '中性成交',
        unknown: '未知成交',
        no_data_title: '当前筛选条件下暂无数据，请调整筛选条件。',
        jump_download_text: '请在APP中打开'
    },
    1: {
        option_name: '期權名稱',
        volume: '成交量',
        value: '成交额',
        direction: '成交方向',
        optionIv: '隐含波动率',
        delta: 'Delta值',
        price: '成交价',
        openInterest: '持倉量',
        buy: '主動買入',
        sell: '主動賣出',
        neutral: '中性成交',
        unknown: '未知成交',
        no_data_title: '當前篩選條件下暫無數據，請調整篩選條件。',
        jump_download_text: '請在APP中打開'
    },
    2: {
        option_name: 'Option Name',
        volume: 'Volume',
        premium: 'Premium',
        value: 'Premium',
        direction: 'Side',
        optionIv: 'IV',
        delta: 'Delta',
        price: 'Price',
        openInterest: 'Open Interest',
        buy: 'Buy',
        sell: 'Sell',
        neutral: 'Mid',
        unknown: 'Unknown',
        no_data_title: 'No data is available under the current filter settings. Please adjust the filter criteria.',
        jump_download_text: 'Please open in the app'
    }
};

export default {
    HK: DEFAULT_DATA,
    SG: DEFAULT_DATA,
    US: DEFAULT_DATA,
    MY: DEFAULT_DATA,
    CA: DEFAULT_DATA,
    JP: DEFAULT_DATA,
    AU: DEFAULT_DATA
};
